<template>
  <div class="relative" ref="dropdownContainer">
    <button
      class="flex items-center justify-between w-full px-2 py-1 border md:py-1 md:text-base"
      :class="{
        'border-[#ccc] text-gray-500 font-light': !isSelectionComplete,
        [`rounded-${radius} h-${height}`]: true,
        'text-gray-500': !isSelectionComplete,
        'bg-[#F7F6FB] font-light border-secondary text-primary':
          isSelectionComplete,
      }"
      type="button"
      @click="toggleDropdown"
    >
      <span class="truncate">{{ selectionText }}</span>
      <DropdownIconSvg
        color="black"
        height="4"
        width="4"
        :class="{ 'rotate-180': isDropdownOpen }"
      />
    </button>

    <!-- Dropdown menu -->
    <div
      v-if="isDropdownOpen"
      class="absolute md:top-[60px] md:right-5 left-auto md:left-0 z-10 divide-y divide-gray-100 shadow rounded-md md:w-[30rem] w-auto text-black"
    >
      <div class="p-4 bg-white rounded-md">
        <!-- Bedrooms Section -->
        <div class="mb-4">
          <p class="mb-2 text-gray-700">Bedrooms</p>
          <div class="flex flex-wrap gap-3">
            <button
              v-for="(range, index) in bedroomRanges"
              :key="index"
              class="w-auto px-3 py-1 mb-2 text-sm text-gray-700 border md:h-8 bg-stone-50"
              :class="{
                'border-secondary text-primary': isBedSelected[index],
                [`rounded-${radius}`]: true,
              }"
              @click="isBedroomSelected(range, index)"
            >
              <span class="w-auto"> {{ range.value }}</span>
            </button>
          </div>
        </div>

        <!-- Bathrooms Section -->
        <div>
          <p class="mb-2 text-gray-700">Bathrooms</p>
          <div class="flex flex-wrap gap-3">
            <button
              v-for="(range, index) in bathroomRanges"
              :key="index"
              class="w-auto px-3 py-1 mb-2 text-sm text-gray-700 border md:h-8 bg-stone-50"
              :class="{
                'border-secondary text-primary bg-primary':
                  isBathSelected[index],
                [`rounded-${radius}`]: true,
              }"
              @click="isBathroomSelected(range, index)"
            >
              {{ range.value }}
            </button>
          </div>
        </div>

        <!-- Confirmation Button -->
        <!-- <button
          v-if="isSelectionComplete"
          class="w-full px-2 py-1 mt-4 text-white border rounded-lg bg-primary focus:outline-none"
          @click="closeDropdown"
        >
          Confirm Selection
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import DropdownIconSvg from "@/components/svg/DropDownIconSvg.vue";
import { ref, onMounted, onUnmounted, computed } from "vue";
export default {
  components: { DropdownIconSvg },
  props: {
    buttonLabel: {
      type: String,
      required: true,
    },
    radius: {
      type: String,
    },
    height: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const dropdownContainer = ref(null);
    const isDropdownOpen = ref(false);
    const selectedBedroom = ref(null);
    const selectedBathroom = ref(null);
    let isBedSelected = ref(false);
    let isBathSelected = ref(false);

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const closeDropdown = () => {
      isDropdownOpen.value = false;
    };

    const handleClickOutside = (event) => {
      if (
        dropdownContainer.value &&
        !dropdownContainer.value.contains(event.target)
      ) {
        closeDropdown();
      }
    };

    // const isSelected = (item, type) => {
    //   if (type === "bedroom") {
    //     return selectedBedroom.value === item;
    //   } else if (type === "bathroom") {
    //     return selectedBathroom.value === item;
    //   }
    // };

    // const handleMenuItemClick = (item, type) => {
    //   if (type === "bedroom") {
    //     selectedBedroom.value = item;
    //   } else if (type === "bathroom") {
    //     selectedBathroom.value = item;
    //   }
    // };

    const isBedroomSelected = (item, index) => {
      selectedBedroom.value = item;
      isBedSelected.value = [];
      isBedSelected.value[index] = true;
    };

    const isBathroomSelected = (item, index) => {
      selectedBathroom.value = item;
      isBathSelected.value = [];
      isBathSelected.value[index] = true;
    };

    const isSelectionComplete = computed(() => {
      return selectedBedroom.value && selectedBathroom.value;
    });

    const selectionText = computed(() => {
      if (isSelectionComplete.value) {
        emit("bathBedSelected", {
          Bedroom: selectedBedroom.value,
          Bathroom: selectedBathroom.value,
        });
        return `${selectedBedroom.value.label}; ${selectedBathroom.value.label}`;
      } else {
        return props.buttonLabel;
      }
    });

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    const bedroomRanges = [
      { label: "studio", value: "studio" },
      { label: "1 Bed", value: "1" },
      { label: "2 Beds", value: "2" },
      { label: "3 Beds", value: "3" },
      { label: "4 Beds", value: "4" },
      { label: "5 Beds", value: "5" },
      { label: "6 Beds", value: "6" },
      { label: "7+ Beds", value: "7+" },
    ];

    const bathroomRanges = [
      { label: "1 Bath", value: "1" },
      { label: "2 Baths", value: "2" },
      { label: "3 Baths", value: "3" },
      { label: "4 Baths", value: "4" },
      { label: "5 Baths", value: "5" },
      { label: "6 Baths", value: "6" },
      { label: "7+ Baths", value: "7+" },
    ];

    return {
      dropdownContainer,
      isDropdownOpen,
      toggleDropdown,
      closeDropdown,
      // selectedBathroom,
      // selectedBedroom,
      // handleMenuItemClick,
      // isSelected,
      isBedroomSelected,
      isBedSelected,
      isBathSelected,
      isBathroomSelected,
      isSelectionComplete,
      selectionText,
      bedroomRanges,
      bathroomRanges,
    };
  },
};
</script>
